import {
  ClassNameReaderPanel,
  DATA_ATTR_LINK_ID, DATA_ATTR_PANEL_INDEX,
  DATA_ATTR_PARA_ID,
  READER_VIEW_CLASS_NAME_PARA_CONTENT_ONLY,
  READER_VIEW_CLASS_NAME_PARA_WRAP
} from "@/shared/utils/reader/constants";
import { CONTENT_CLASSES } from "@/shared/utils/content/content.constants";

export const getClosestReaderPanel = (element) => {
  if (element) {
    const nonTextNode = element.nodeType === Element.TEXT_NODE
      ? element.parentElement
      : element;

    if (!nonTextNode) {
      return;
    }

    return nonTextNode.classList.contains(ClassNameReaderPanel)
      ? nonTextNode
      : nonTextNode.closest("." + ClassNameReaderPanel);
  }

  return null;
};

export const getClosestParaWrapElement = (childNode) => {
  if (childNode) {
    const nonTextNode = childNode.nodeType === Node.TEXT_NODE ? childNode.parentElement : childNode;

    if (nonTextNode) {
      if (nonTextNode.classList.contains(READER_VIEW_CLASS_NAME_PARA_WRAP)) {
        return nonTextNode;
      }

      return nonTextNode.closest("." + READER_VIEW_CLASS_NAME_PARA_WRAP);
    }
  }

  return null;
};

export const getParaContentOnlyElement = (node) => {
  if (node) {
    const nonTextNode = (node.nodeType === Node.TEXT_NODE ? node.parentElement : node);

    if (nonTextNode) {
      if (nonTextNode.classList.contains(READER_VIEW_CLASS_NAME_PARA_CONTENT_ONLY)) {
        return nonTextNode;
      }

      const paraContentOnlyEl = nonTextNode.querySelector(
        "." + READER_VIEW_CLASS_NAME_PARA_CONTENT_ONLY
      );
      if (paraContentOnlyEl) {
        return paraContentOnlyEl;
      }

      const nearestParaWrapElement = nonTextNode.closest("." + READER_VIEW_CLASS_NAME_PARA_WRAP);

      if (nearestParaWrapElement) {
        if (nearestParaWrapElement.classList?.contains(READER_VIEW_CLASS_NAME_PARA_CONTENT_ONLY)) {
          return nearestParaWrapElement;
        }

        return nearestParaWrapElement.querySelector("." + READER_VIEW_CLASS_NAME_PARA_CONTENT_ONLY);
      }
    }
  }

  return null;
};

export const getParaWrapElementByIdAndView = (id, scrollerView) => {
  if (!id || !scrollerView) {
    return null;
  }

  return scrollerView.querySelector(
    "." + READER_VIEW_CLASS_NAME_PARA_WRAP + "[" + DATA_ATTR_PARA_ID + "=\"" + id + "\"]"
  );
};

export const getTopMiddleOfParaContentFirstLine = (paraWrap, paraContentOnly) => {
  const paraContentComputedStyle = window.getComputedStyle(paraContentOnly);

  const fontSize = parseFloat(paraContentComputedStyle["font-size"]);
  const lineHeight = parseFloat(paraContentComputedStyle["line-height"]);

  let deltaParaContentTopToParaWrapTop, lineCount;

  if (paraWrap === paraContentOnly) {
    const paddingTop = parseFloat(window.getComputedStyle(paraWrap)["padding-top"]);

    deltaParaContentTopToParaWrapTop = paddingTop;
    lineCount = Math.ceil(
      Math.floor(
        paraWrap.offsetHeight
        - paddingTop
        - parseFloat(window.getComputedStyle(paraWrap)["padding-bottom"])
      ) / lineHeight);
  } else {
    // {offsetTop}, because:
    // Firstly, "inline" elements have offset regarding "block" parent
    // Secondly, it comprises top padding of the parent
    //   and elements heights before content like para headers (Main App only)
    deltaParaContentTopToParaWrapTop = paraContentOnly.offsetTop;
    lineCount = Math.ceil(paraContentOnly.offsetHeight / lineHeight);
  }

  const isSingleLineOfTextContent = lineCount === 1;

  const middleTop = deltaParaContentTopToParaWrapTop
    // to be centered regarding the first text line
    + (isSingleLineOfTextContent ? lineHeight / 2 : fontSize / 2);

  return {
    middleTop,
    fontSize,
    isSingleLineOfTextContent,
  };
};

export const getParaWrapAndContentElementsByIdAndView = (id, scrollerView) => {
  if (!id || !scrollerView) {
    return null;
  }

  const paraWrap = getParaWrapElementByIdAndView(id, scrollerView);

  return {
    paraWrap,
    paraContentOnly: getParaContentOnlyElement(paraWrap),
  };
};

export const getParaIdByParaElement = (paraElement) => {
  if (!paraElement) {
    return null;
  }

  return paraElement.getAttribute(DATA_ATTR_PARA_ID);
};

export const getClosestLinkElement = (element) => {
  if (element) {
    const nonTextNode = element.nodeType === Element.TEXT_NODE
      ? element.parentElement
      : element;

    if (!nonTextNode) {
      return;
    }

    return nonTextNode.classList.contains(CONTENT_CLASSES.EGW_LINK)
      ? nonTextNode
      : nonTextNode.closest("." + CONTENT_CLASSES.EGW_LINK);
  }

  return null;
};

export const getLinkIdByLinkElement = (element) => {
  if (!element) {
    return null;
  }

  return element.getAttribute(DATA_ATTR_LINK_ID);
};

export const getClosestPanelElement = (element) => {
  if (element) {
    const nonTextNode = element.nodeType === Element.TEXT_NODE
      ? element.parentElement
      : element;

    if (!nonTextNode) {
      return;
    }

    return nonTextNode.classList.contains(ClassNameReaderPanel)
      ? nonTextNode
      : nonTextNode.closest("." + ClassNameReaderPanel);
  }

  return null;
};

export const getPanelIndexByPanelElement = (element) => {
  if (!element) {
    return null;
  }

  return element.getAttribute(DATA_ATTR_PANEL_INDEX);
};
